import {
	default as React,
	type ReactNode,
	createContext,
	useContext,
} from "react";
import { useComplexState } from "use-complex-state";
import { EmailTopicsReducer } from "../reducers/EmailTopicsReducer";

const EmailTopicsContext = createContext({
	state: EmailTopicsReducer.getInitialState(),
	actions: EmailTopicsReducer.actions,
});

export const useEmailTopicsContext = () => useContext(EmailTopicsContext);

export const EmailTopicsProvider = ({ children }: { children: ReactNode }) => {
	const [state, actions] = useComplexState({
		initialState: EmailTopicsReducer.getInitialState(),
		reducers: EmailTopicsReducer.caseReducers,
	});

	return (
		<EmailTopicsContext.Provider value={{ state, actions }}>
			{children}
		</EmailTopicsContext.Provider>
	);
};
